import React from "react"
import { ThemeProvider } from "styled-components"
import "reset-css"
import styled from "styled-components"
import { StaticQuery, graphql } from "gatsby"
import { motion } from "framer-motion"
import { ParallaxProvider } from "react-scroll-parallax"

import GlobalContext from "../components/global-context"
import LayoutContextProvider from "../components/layout-context"
import LoadedContextProvider from "../components/loaded-context"

import theme from "../theme"

import "../assets/stylesheets/site.scss"

import Cursor from "../components/cursor"
import Nav from "../components/nav/index"
import Seo from "../components/seo"
import Noise from "../components/noise"
import PageContent from "../components/page-container"
import BackgroundTexture from "../components/background-texture"

const PageContainer = styled(motion.div)`
  width: 100%;
  position: relative;
  z-index: 2;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow: auto;
`

// const Content = styled.div`
//   flex-grow: 1;
// `

const BackgroundTextureEl = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #161519;
  z-index: -1;

  & > div {
    height: 100%;
  }
`

// const ScrollBarcontainer = styled.div.attrs({id: 'scrollbar-container'})`
//   @media ${ props => props.theme.mobileUp } {
//     height: 100vh;
//     overflow: auto;
//     position: relative;
//     z-index: 2;
//   }
// `

const Layout = props => {
  return (
    <ParallaxProvider>
      <ThemeProvider theme={theme}>
        <LayoutContextProvider>
          <GlobalContext>
            <LoadedContextProvider>
              <Seo seoProps={props.wp.options.seo} />

              <PageContainer>
                <Nav />

                {/* <Grid /> */}

                <PageContent
                  path={props.path}
                  footerOptions={props.wp.options.footer}
                  layout={props.pageContext.layout}
                >
                  {props.children}
                </PageContent>

                <Noise />

                <BackgroundTextureEl>
                  <BackgroundTexture />
                </BackgroundTextureEl>
              </PageContainer>

              <Cursor />
            </LoadedContextProvider>
          </GlobalContext>
        </LayoutContextProvider>
      </ThemeProvider>
    </ParallaxProvider>
  )
}

export default props => (
  <StaticQuery
    query={graphql`
      query {
        wp {
          options {
            seo {
              title
              description
              image {
                localFile {
                  publicURL
                }
              }
            }

            footer {
              footerAddress
              footerInstagramUrl
              footerVimeoUrl
              footerContactInformation {
                footerContactInformationContact
              }
            }
          }
        }
      }
    `}
    render={layoutData => <Layout {...layoutData} {...props} />}
  />
)
